import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39ad8233"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-BG" }
const _hoisted_2 = { class: "home" }
const _hoisted_3 = { class: "explorer" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "tabs" }
const _hoisted_6 = {
  key: 0,
  class: "api-grid"
}
const _hoisted_7 = { class: "input" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Input", -1))
const _hoisted_9 = {
  key: 0,
  class: "properties"
}
const _hoisted_10 = { class: "field" }
const _hoisted_11 = { class: "description" }
const _hoisted_12 = ["onChange"]
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "field" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 1,
  class: "description"
}
const _hoisted_17 = ["type", "name", "placeholder", "onUpdate:modelValue"]
const _hoisted_18 = ["onChange"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", { type: "file" }, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = ["placeholder", "min", "max", "onUpdate:modelValue"]
const _hoisted_22 = ["onUpdate:modelValue"]
const _hoisted_23 = ["placeholder", "onUpdate:modelValue"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: undefined }, "-", -1))
const _hoisted_25 = ["value", "selected"]
const _hoisted_26 = {
  key: 7,
  class: "properties"
}
const _hoisted_27 = ["onUpdate:modelValue"]
const _hoisted_28 = ["value"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "output" }
const _hoisted_32 = { class: "output-header" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Output", -1))
const _hoisted_34 = ["id"]
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { class: "image-container" }
const _hoisted_38 = ["src"]
const _hoisted_39 = ["src"]
const _hoisted_40 = {
  key: 2,
  class: "output-image placeholder"
}
const _hoisted_41 = {
  key: 3,
  class: "generation-time loading-bar"
}
const _hoisted_42 = ["value"]
const _hoisted_43 = {
  key: 4,
  class: "generation-time"
}
const _hoisted_44 = {
  key: 5,
  class: "generation-time"
}
const _hoisted_45 = {
  key: 1,
  class: "code"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Use our npm package to get started or check out our "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://docs.prodia.com/getting-started/" }, "getting started guide"),
  /*#__PURE__*/_createTextVNode(". ")
], -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Run your generation and save it to a file.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModelTags = _resolveComponent("ModelTags")!
  const _component_highlightjs = _resolveComponent("highlightjs")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedJobType) = $event)),
          class: "job-type"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobTypes, (jobType) => {
            return (_openBlock(), _createElementBlock("option", { value: jobType }, _toDisplayString(jobType), 9, _hoisted_4))
          }), 256))
        ], 512), [
          [_vModelSelect, _ctx.selectedJobType]
        ]),
        _createVNode(_component_ModelTags, {
          model: { type: _ctx.selectedJobType }
        }, null, 8, ["model"]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass({
							tab: true,
							selected: _ctx.selectedTab === 'explore'
						}),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedTab = 'explore'))
          }, " 🪐 Explore ", 2),
          _createElementVNode("div", {
            class: _normalizeClass({
							tab: true,
							selected: _ctx.selectedTab === 'code'
						}),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedTab = 'code'))
          }, " 🚀 Code ", 2)
        ]),
        (_ctx.selectedTab === 'explore')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                (_ctx.selectedProperties)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedJobInputs, (input, i) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("label", null, _toDisplayString(input.label), 1),
                          _createElementVNode("p", _hoisted_11, _toDisplayString(input.description) + " Max " + _toDisplayString(input.maxSize / 1000 ** 2) + " MB, " + _toDisplayString(input.maxWidth) + "x" + _toDisplayString(input.maxHeight) + ". Min " + _toDisplayString(input.minWidth) + "x" + _toDisplayString(input.minHeight) + ". ", 1),
                          _createElementVNode("input", {
                            type: "file",
                            accept: "image/*",
                            onChange: 
										(event) => _ctx.handleImageUpload(event, i)
									,
                            ref_for: true,
                            ref: "fileInput",
                            class: "file-input"
                          }, null, 40, _hoisted_12),
                          (_ctx.imagePreviews[i])
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _ctx.imagePreviews[i],
                                alt: "preview",
                                style: {"width":"100%"}
                              }, null, 8, _hoisted_13))
                            : _createCommentVNode("", true)
                        ]))
                      }), 256)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedProperties, (property, key) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          (
										property.type !== 'object' &&
										!(
											property.type === 'array' &&
											!property.items?.enum
										)
									)
                            ? (_openBlock(), _createElementBlock("label", _hoisted_15, _toDisplayString(key), 1))
                            : _createCommentVNode("", true),
                          (property.description)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(property.description), 1))
                            : _createCommentVNode("", true),
                          (
										property.type === 'string' &&
										!property.enum &&
										property.format !== 'filename'
									)
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 2,
                                type: property.type,
                                name: property.name,
                                placeholder: 
										property.default ||
										property.examples?.[0] ||
										''
									,
                                "onUpdate:modelValue": ($event: any) => ((_ctx.config[key]) = $event)
                              }, null, 8, _hoisted_17)), [
                                [_vModelDynamic, _ctx.config[key]]
                              ])
                            : _createCommentVNode("", true),
                          (
										property.type === 'string' &&
										property.format === 'filename'
									)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 3,
                                onChange: 
										(event) =>
											_ctx.handleFileInputUpload(event, key)
									
                              }, _hoisted_20, 40, _hoisted_18))
                            : _createCommentVNode("", true),
                          (
										property.type === 'number' ||
										property.type === 'integer' ||
										typeof property.default === 'number'
									)
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 4,
                                type: "number",
                                placeholder: property.default,
                                min: property.minimum,
                                max: property.maximum,
                                "onUpdate:modelValue": ($event: any) => ((_ctx.config[key]) = $event)
                              }, null, 8, _hoisted_21)), [
                                [_vModelText, _ctx.config[key]]
                              ])
                            : _createCommentVNode("", true),
                          (property.type === 'boolean')
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 5,
                                type: "checkbox",
                                "onUpdate:modelValue": ($event: any) => ((_ctx.config[key]) = $event)
                              }, null, 8, _hoisted_22)), [
                                [_vModelCheckbox, _ctx.config[key]]
                              ])
                            : _createCommentVNode("", true),
                          (
										property.type === 'string' &&
										property.enum
									)
                            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                key: 6,
                                placeholder: property.default,
                                "onUpdate:modelValue": ($event: any) => ((_ctx.config[key]) = $event)
                              }, [
                                _hoisted_24,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(property.enum, (option) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    value: option,
                                    selected: 
											option === _ctx.config[key] ||
											_ctx.config[key] === undefined
										
                                  }, _toDisplayString(option), 9, _hoisted_25))
                                }), 256))
                              ], 8, _hoisted_23)), [
                                [_vModelSelect, _ctx.config[key]]
                              ])
                            : _createCommentVNode("", true),
                          (
										property.type === 'array' &&
										property.items?.enum
									)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                (
											typeof _ctx.config[key] === 'object' &&
											_ctx.config[key] instanceof Array
										)
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.config[key], (item, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: item,
                                        class: "array-item"
                                      }, [
                                        _withDirectives(_createElementVNode("select", {
                                          "onUpdate:modelValue": ($event: any) => ((_ctx.config[key][index]) = $event)
                                        }, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(property.items
													.enum, (option) => {
                                            return (_openBlock(), _createElementBlock("option", { value: option }, _toDisplayString(option), 9, _hoisted_28))
                                          }), 256))
                                        ], 8, _hoisted_27), [
                                          [_vModelSelect, _ctx.config[key][index]]
                                        ]),
                                        _createElementVNode("button", {
                                          onClick: ($event: any) => (
												_ctx.config[key].splice(index, 1)
											)
                                        }, " Remove ", 8, _hoisted_29)
                                      ]))
                                    }), 128))
                                  : _createCommentVNode("", true),
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (
											_ctx.config[key] = _ctx.config[key]
												? [
														..._ctx.config[key],
														property.items.enum[0]
												  ]
												: [property.items.enum[0]]
										)
                                }, " Add ", 8, _hoisted_30)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 256))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  (_ctx.captchaId)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "captcha",
                        id: _ctx.captchaId
                      }, null, 8, _hoisted_34))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: _normalizeClass({
									run: true,
									loading: _ctx.isGenerating
								}),
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.run && _ctx.run(...args)))
                  }, [
                    (_ctx.isGenerating)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_35, "⚙"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_36, "Run ✨"))
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_37, [
                  (
									(_ctx.image || _ctx.selectedJobExample) &&
									_ctx.responseType === 'video'
								)
                    ? (_openBlock(), _createElementBlock("video", {
                        key: 0,
                        class: "output-image",
                        src: _ctx.image || _ctx.selectedJobExample,
                        controls: "",
                        autoplay: "",
                        loop: ""
                      }, null, 8, _hoisted_38))
                    : (
									(_ctx.image || _ctx.selectedJobExample) &&
									_ctx.responseType === 'image'
								)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          class: "output-image",
                          src: _ctx.image || _ctx.selectedJobExample
                        }, null, 8, _hoisted_39))
                      : (_openBlock(), _createElementBlock("div", _hoisted_40, " 🌄 ")),
                  (_ctx.loadingBar !== undefined)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        _createElementVNode("progress", {
                          value: _ctx.loadingBar,
                          max: "1"
                        }, null, 8, _hoisted_42)
                      ]))
                    : (_ctx.generationTime)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_43, _toDisplayString((_ctx.generationTime / 1000).toFixed(2)) + "s ", 1))
                      : (_openBlock(), _createElementBlock("p", _hoisted_44, " "))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.selectedTab === 'code')
          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
              _createElementVNode("section", null, [
                _hoisted_46,
                _createVNode(_component_highlightjs, {
                  language: "shell",
                  code: "npm install prodia --save"
                })
              ]),
              _createElementVNode("section", null, [
                _createElementVNode("p", null, [
                  _createTextVNode(" Declare your token. Pro+ users can get one in the "),
                  _createVNode(_component_router_link, { to: "/api" }, {
                    default: _withCtx(() => [
                      _createTextVNode("API Dashboard")
                    ]),
                    _: 1
                  }),
                  _createTextVNode(". ")
                ]),
                _createVNode(_component_highlightjs, {
                  language: "shell",
                  code: "export PRODIA_TOKEN=xxx"
                })
              ]),
              _createElementVNode("section", null, [
                _hoisted_47,
                _createVNode(_component_highlightjs, {
                  language: "shell",
                  code: _ctx.javascriptCode
                }, null, 8, ["code"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}